import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import EdCreateProductComponent from '@/courses/components/ed-create-product/ed-create-product.component.vue';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';
import { COURSE_TEMPLATE_EVENTS, PRODUCT_TYPES } from '@/course-templates/values/course-templates.values'

@Component({
  name: 'create-course-template',
  components: {
    EdCreateProduct: EdCreateProductComponent
  }
})
export default class CreateCourseTemplateView extends Vue {

  /* Data */
  public saving: boolean = false;
  public template: any = {};
  public productType: PRODUCT_TYPES = PRODUCT_TYPES.TEMPLATE;

  /* Computed */
  get templateId(): number {
    return Number(this.$route.params.id);
  }

  get title() {
    if(this.templateId) {
      return `${this.$i18n.t('courseTemplates.createCourseTemplate.updateTemplate', {templateName: this.template.title})}`; 
    } else {
      return this.$i18n.t('courseTemplates.createCourseTemplate.createTemplate');
    }
  }

  /* Methods */
  public save ({formData, uploadedImage}) {
    this.saving = true;
    if(this.templateId) this.updateTemplate(formData, this.templateId, uploadedImage?.file)
    else this.createTemplate(formData, uploadedImage?.file)
  }

  async createTemplate(template, image) {
    try {
      let res = await this.$CourseTemplates.Services.createNewCourseTemplate(template, image);
      this.$router.push({ 
        name: PRIVATE_ROUTES.SUBJECT_TEMPLATE.NAME,
        params: { courseId: res.courseTemplateId, mode: 'edit', templateType: 'my' } 
      });
    } catch {
      this.$EdToast.create({ 
        msg:  `${this.$t('courseTemplates.errors.errorSavingTemplate')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
    }
  }

  async updateTemplate(template, templateId, image) {
    try {
      await this.$CourseTemplates.Services.updateCourseTemplate(template, image, templateId);
      this.$router.push({ 
        name: PRIVATE_ROUTES.SUBJECT_TEMPLATE.NAME,
        params: { courseId: templateId, mode: 'edit', templateType: 'my' } 
      });
    } catch(err) {
      this.$EdToast.create({ 
        msg:  `${this.$t('courseTemplates.errors.errorSavingTemplate')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.saving = false;
    }
  }

  /* Hooks */
  created() {
    this.$edEventBus.$on(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM, this.save);
  }

  beforeDestroy() {
    this.$edEventBus.$off(COURSE_TEMPLATE_EVENTS.SAVE_COURSE_FORM);
  }

  /* Watch */
  @Watch('templateId', {immediate: true})
  async getCourseTemplate() {
    if(this.templateId) {
      try {
        this.template = await this.$CourseTemplates.Store.getCourseTemplate({
          templateId: this.templateId,
        });
      } catch (err){
        this.$EdToast.create({ 
          msg:  `${this.$t('courseTemplates.errors.errorLoadingCourseTemplate')}`,
          type: TOAST_TYPES.DANGER,
          top: '3rem',
          timeout: 3000
        });
      }
    }
  }
}
